import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        tableContent: {
            maxHeight: 460,
        },
    }
})

export default useStyles
